import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, Observable } from 'rxjs';

import { WebviewService } from '@features/termination/services/webview';
import * as fromActions from '@features/termination/store/actions';

@Injectable()
export class WebviewEffect {
  private readonly actions$: Actions = inject(Actions);

  private readonly webviewService: WebviewService = inject(WebviewService);

  public closeWebview$: Observable<void> = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(fromActions.CloseWebView),
        map(() => {
          return this.webviewService.closeWebView();
        }),
      );
    },
    { dispatch: false },
  );

  public openContact$: Observable<void> = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(fromActions.OpenContactWebView),
        map(() => {
          return this.webviewService.openContact();
        }),
      );
    },
    { dispatch: false },
  );
}
